import React from 'react';
import { IoLinkOutline } from 'react-icons/io5';
import { usePostHog } from 'posthog-js/react';
import './GoToLinkButton.css';

// This component is a button that, when clicked, navigates to the link of the provided clip in a new tab
// If the clip is null or undefined, or does not have a link, the button will be disabled
export function GoToLinkButton({ clip, size = "40px", color = "#D9D9D9" }) {
    const posthog = usePostHog();
    const isDisabled = !clip || !clip.link;

    const handleClick = (event) => {
        event.stopPropagation(); // Prevent event from propagating to parent
        posthog.capture('go_to_link_button_clicked', { clip: clip.id, clip_title: clip.title, disabled: isDisabled });
        if (isDisabled) return; // Early return if button is disabled
        // Navigate to clip's link in a new tab
        window.open(clip.link, '_blank', 'noopener,noreferrer');
    };

    return (
        <button
            onClick={handleClick}
            className={`goToLinkButton ${isDisabled ? 'disabled' : ''}`}
            disabled={isDisabled}
        >
            <IoLinkOutline color={color} size={size} strokeWidth={5} />
        </button>
    );
}
